import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../../config/api";

// NOTE: Fetch total downloads
export const fetchTotalDownloads = createAsyncThunk(
	"reports/download/totalDownloads",
	async () => {
		const response = await api.get("reports/download/total-downloads");
		return response.data;
	}
);

// NOTE: Fetch total users
export const fetchTotalUsers = createAsyncThunk(
	"reports/download/totalUsers",
	async () => {
		const response = await api.get("reports/download/total-users");
		return response.data;
	}
);

// NOTE: Fetch total tracks
export const fetchTotalTracks = createAsyncThunk(
	"reports/download/totalTracks",
	async () => {
		const response = await api.get("reports/download/total-tracks");
		return response.data;
	}
);

// NOTE: Search tracks
export const searchTracks = createAsyncThunk(
	"reports/download/searchTracks",
	async (query) => {
		const { offset, limit, search, startDate, endDate } = query;
		// Build query string with encodeURIComponent to handle special characters
		const queryParams = new URLSearchParams();
		queryParams.append("page", Number.parseInt(offset / limit) + 1);
		if (search) queryParams.append("query", search);
		if (startDate) queryParams.append("startDate", startDate);
		if (endDate) queryParams.append("endDate", endDate);

		const response = await api.get(
			`reports/download/search-tracks?${queryParams.toString()}`
		);
		return response.data;
	}
);
